import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {SelectItem} from '../../models/select-item';

@Component({
  selector: 'p-group-multiselect',
  templateUrl: './p-group-multiselect.component.html',
  styleUrls: ['./p-group-multiselect.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PGroupMultiselectComponent implements OnInit,  OnChanges {

  public selectedOptions: Array<SelectItem> = new Array<SelectItem>();
  @Input() selectedItemsLabel = 'All';
  @Input() options: Array<SelectItem>;
  @Input() selectedCompany: SelectItem;
  @Input() selectedCompanies: SelectItem[];
  @Input() preFilteredAccounts: any;
  @Input() isReset: boolean;
  @Input() filterBy = 'searchText';
  @Output() selectedOptionsEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() inputWidth: string;
  @Input() filter = false;
  originalOptions: SelectItem[] = [];
  constructor() {
  }

  ngOnInit() {
    if (this.selectedCompany) {
      this.handleSelectedCompany(this.selectedCompany);
    } else if (this.selectedCompanies) {
      this.selectedCompanies.forEach(company => {
        this.handleSelectedCompany(company);
      });
    } else if (this.preFilteredAccounts && (this.preFilteredAccounts['parentOptions'].length > 0 || this.preFilteredAccounts['childOptions'].length > 0)) {
      const selectionArray: any = [];
      this.preFilteredAccounts['parentOptions'].forEach(element => {
        const parentElement = element.value;
        selectionArray[parentElement['id']] = parentElement['selectedChildOptions'];
      });
      this.handlePrefilteredCompaniesChildren(this.preFilteredAccounts['childOptions']);
      this.handlePrefilteredCompaniesParents(selectionArray);
      this.getSelectedParentAndChildOptions();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && changes.options.currentValue?.length) {
      this.originalOptions = changes.options.currentValue.map(o => ({ ...o }));
    }
  }

  public onChangeMultiSelect($event) {
    if ($event.itemValue) {
      this.handleMultiSelectOptionClicked($event);
    } else {
      this.handleMultiSelectHeaderClicked($event);
    }
    this.getSelectedParentAndChildOptions();
  }

  private handleMultiSelectOptionClicked(event) {
    let elementChecked = false;
    event.value.forEach(element => {
      if (element.id === event.itemValue.value.id) {
        elementChecked = true;
      }
    });
    if (elementChecked) {
      this.options.forEach((option) => {
        if (option.value.id === event.itemValue.value.id) {
          option.value.selectedChildOptions = [];
          option.value.childOptions.forEach(element => {
            option.value.selectedChildOptions.push(element.value);
          });
        }
      });
    } else {
      this.options.forEach((option) => {
        if (option.value.id === event.itemValue.value.id) {
          option.value.selectedChildOptions = [];
        }
      });
    }
  }

  private handleMultiSelectHeaderClicked(event) {
    if (event.value.length === this.options.length) {
      this.options.forEach((option) => {
        option.value.selectedChildOptions = [];
        option.value.childOptions.forEach(element => {
          option.value.selectedChildOptions.push(element.value);
        });
      });
    } else {
      this.options.forEach((option) => {
        option.value.selectedChildOptions = [];
      });
    }
  }

  public onChangeChildOptionCheckbox(option) {
    if (option.value.childOptions.length !== option.value.selectedChildOptions.length) {
      this.selectedOptions = this.selectedOptions.filter((selectedOption) => selectedOption.id !== option.value.id);
    } else {
      this.selectedOptions = [...this.selectedOptions];
      this.selectedOptions.push(option.value);
    }
    this.getSelectedParentAndChildOptions();
  }

  public onClickChildOptionCheckbox(event) {
    event.stopPropagation();
  }

  public onClickChildOptionContainer(event) {
    event.stopPropagation();
  }

  public getSelectedItemsLabel() {
    const selectedItemLabels = [];
    this.options.forEach((option) => {
      if (option.value.selectedChildOptions.length !== 0) {
        if (option.value.childOptions.length === option.value.selectedChildOptions.length) {
          selectedItemLabels.push(option.label);
        } else {
          option.value.selectedChildOptions.forEach((selectedChildOption) => {
            const index = option.value.childOptions.findIndex((childOption) => childOption.value === selectedChildOption);
            selectedItemLabels.push(option.value.childOptions[index].label);
          });
        }
      } else if (this.selectedOptions.findIndex(x => x.id === option.value.id) !== -1) {
        selectedItemLabels.push(option.label);
      }
    });
    if (selectedItemLabels.length <= 0) {
      return this.selectedItemsLabel;
    } else if (selectedItemLabels.length < 3) {
      return selectedItemLabels.join(',');
    } else {
      return selectedItemLabels.length + ' items selected';
    }
  }

  public getSelectedParentAndChildOptions() {
    const selectedResults = {
      parentOptions: [],
      childOptions: []
    };
    this.options.forEach((option) => {
      if (option.value.selectedChildOptions.length !== 0) {
        if (option.value.childOptions.length === option.value.selectedChildOptions.length) {
          selectedResults.parentOptions.push(option);
        } else {
          option.value.selectedChildOptions.forEach((childOption) => {
            selectedResults.childOptions.push(childOption);
          });
        }
      } else if (option.value.childOptions.length === 0) {
        const j = this.selectedOptions.findIndex(x => x.id === option.value.id);
        if (j !== -1) {
          selectedResults.parentOptions.push(option);
        }
      }
    });
    this.selectedOptionsEvent.emit(selectedResults);
  }

  private handleSelectedCompany(selectedOption) {
    this.options.forEach((option) => {
      if (option.value.id === selectedOption.value.id) {
        option.value.selectedChildOptions = [];
        selectedOption.value.childOptions.forEach(element => {
          option.value.selectedChildOptions.push(element.value);
        });
        this.selectedOptions = [...this.selectedOptions];
        this.selectedOptions.push(option.value);
      }
    });
    this.getSelectedParentAndChildOptions();
  }

  private handlePrefilteredCompaniesParents(selectedOptions) {
    this.options.forEach((option) => {
      if (selectedOptions[option.value.id]) {
        option.value.selectedChildOptions = [];
        selectedOptions[option.value.id].forEach(element => {
          option.value.selectedChildOptions.push(element);
        });
        this.selectedOptions.push(option.value);
      }
    });
  }

  private handlePrefilteredCompaniesChildren(childOptionsFilter) {
    childOptionsFilter.forEach(childOptionFilter => {
      this.options.forEach((option) => {
        option.value.childOptions.forEach((childOption) => {
          if (childOption.value === childOptionFilter) {
            option.value.selectedChildOptions.push(childOption.value);
          }
        });
      });
    });
  }

  getChildStyle() {
    return {
      width: this.inputWidth,
      display: 'grid'
    };
  }

  reset() {
    this.options.forEach((option) => {
      option.value.selectedChildOptions = [];
    });
    this.selectedOptions = [];
    this.getSelectedParentAndChildOptions();
  }

  onCustomFilter(event: any) {
    const query = (event.filter || '').toLowerCase().trim();
    if (!query) {
      this.options = [...this.originalOptions];
      return;
    }
    const tokens = query.split(/\s+/); // espace = OR
    this.options = this.originalOptions.filter(option => {
      const text = option.searchText || '';
      return tokens.some(token => text.includes(token));
    });
  }

}
